export default class Nav {
  constructor() {
    this.$nav = $(".page-header");
    this.$hamburger = $(".page-header .js-hamburger");
    this.scrollTop = 0;
    this.scrolledDown = false;
    this.height = 0;
  }

  init() {
    if(!this.$nav.length) return;

    if(!this.$nav.hasClass('page-header--fixed')){
      this.onScroll();
    }
    this.toggleMenu();
    this.menuLinks();
  }

  update(winWidth) {
    if(!this.$nav.length) return;

    this.height = this.$nav[0].offsetHeight;

    if(winWidth >= 992 && this.$nav.hasClass('open')) {
      this.$nav.removeClass('open');
      $('html').removeClass('overflow-hidden');
      this.$hamburger.removeClass('active');
    }
  }

  toggleMenu() {
    let self = this;

    this.$hamburger.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('html').toggleClass('overflow-hidden');
      self.$nav.toggleClass('open');
    })
  }

  menuLinks() {
    let self = this;

    this.$nav.find(".link").on('click', function(e) {
      self.$hamburger.removeClass('active');
      $('html').removeClass('overflow-hidden');
      self.$nav.removeClass('open');
    });
  }

  onScroll() {
    $(window).unbind('scroll');
    let self = this;
    this.height = this.$nav[0].offsetHeight;
    this.$nav.css("position", "absolute");

    setTimeout(function() {
      if($(window).scrollTop() > self.height) {
        self.$nav.addClass("scrolled");
        self.$nav.css("position", "fixed");
        setTimeout(() => {
          self.$nav.addClass("scroll-start");
        }, 250);
      }
    }, 0);

    $(window).scroll(function(){
      let s = $(window).scrollTop();
      let to = null;
      self.scrolledDown = self.scrollTop < s && s > self.height;

      if(s === 0) {
        self.$nav.css("position", "absolute");
        self.$nav.removeClass("scroll-start");
        clearTimeout(to);
      } else if(s > self.height && !self.$nav.hasClass("scroll-start")) {
        self.$nav.css("position", "fixed");
        to = setTimeout(() => {
          self.$nav.addClass("scroll-start");
        }, 0);
      } else if(s <= self.height && self.scrollTop < s && self.$nav.hasClass("scroll-start")) {
        self.$nav.removeClass("scroll-start");
        clearTimeout(to);
      }

      self.scrollTop = $(window).scrollTop();

      if (!self.$nav.hasClass("scrolled") && self.scrolledDown) {
        self.$nav.addClass("scrolled");
      }

      if (self.$nav.hasClass("scrolled") && !self.scrolledDown) {
        self.$nav.removeClass("scrolled");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./static/js/components/Nav.js